import React from 'react';
import PropTypes from 'prop-types';

/**
 * Panel - A wrapper that renders a standard HTML nav with Bulma class names
 *
 * This component accepts the same props as Bloomer Panel for easy migration
 */
const Panel = ({ className, children, style, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['panel'];

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <nav className={getClassNames()} style={style} {...props}>
      {children}
    </nav>
  );
};

Panel.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

Panel.defaultProps = {
  className: '',
  style: {},
  children: null,
};

export default Panel;
